import React from 'react'
import PropTypes from 'prop-types'
import DynamicImage from '@app/components/dynamic-image'

/**
 * PDCHomeServicesPushTile component.
 * @typedef {Object} PDCFooterPaymentIconProps
 * @property {object} paymentIcon - Payment icon
 * @property {string} name - Name of payment mode

 * @returns {React.ReactElement} - PDCHomeServicesPushTile component.
 */
export const PDCFooterPaymentIcon = ({paymentIcon, name, custom}) => {
    return (
        <DynamicImage
            src={`${custom?.paymentIcon?.disBaseLink || paymentIcon?.url}[?sw={width}]`}
            widths={[32]}
            imageProps={{
                width: '32px',
                loading: 'lazy',
                alt: name,
                objectFit: 'contain'
            }}
        />
    )
}

PDCFooterPaymentIcon.propTypes = {
    paymentIcon: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    custom: PropTypes.object
}
